import React from 'react';

const LanguageContext = React.createContext({
  language: null,
  setLanguage: () => {}
});

export default LanguageContext;
